import type { MessageKey } from '../../i18n';
import { createColumnsHook, type ColumnsState } from '../../lib/table-columns';

/**
 * Optional columns of the checklist list, the counterpart of the test case
 * one. Key and title are not here: they identify the row and are always shown.
 */
export const CHECKLIST_COLUMNS = [
  'folder',
  'status',
  'labels',
  'environment',
  'layer',
  'module',
  'items',
  'runs',
  'author',
  'updated',
] as const;

export type ChecklistColumn = (typeof CHECKLIST_COLUMNS)[number];

export const CHECKLIST_COLUMN_LABELS: Record<ChecklistColumn, MessageKey> = {
  folder: 'common.folder',
  status: 'common.status',
  labels: 'labels.title',
  environment: 'common.environment',
  layer: 'common.layer',
  module: 'common.module',
  items: 'checklists.columnItems',
  runs: 'checklists.columnRuns',
  author: 'common.author',
  updated: 'common.updated',
};

/** The set the list has always shown. */
const DEFAULT_COLUMNS: ChecklistColumn[] = ['folder', 'items', 'updated'];

export const CHECKLIST_COLUMNS_STORAGE_KEY = 'tms.checklistColumns';

export type ChecklistColumnsState = ColumnsState<ChecklistColumn>;

export const useChecklistColumns = createColumnsHook({
  columns: CHECKLIST_COLUMNS,
  defaults: DEFAULT_COLUMNS,
  storageKey: CHECKLIST_COLUMNS_STORAGE_KEY,
});
